import { InjectionToken, type Type } from '@angular/core';

/**
 * Extra sections below the OE edit form, contributed from outside.
 *
 * The sheet lives here, but not everything a station or a Stelle *is*
 * belongs to this module. The skills it requires belong to `skill`, and
 * `skill.organization_id` already points at `organization` — importing the
 * panel here would close the circle the lint rule refuses for good reason.
 *
 * So the sheet declares the hole and the application fills it, the same way
 * the person drawer does with `PERSON_DETAIL_TABS`. Not to be confused with
 * `ORG_UNIT_SETTINGS_SECTIONS`, which names the tabs of the configuration
 * panel beside the chart; these are sections of the edit sheet itself.
 */

/** Which kind of post the sheet is editing. */
export type OrgEditPostKind = 'station' | 'position';

export interface OrgEditSheetSection {
  /** Unique among the contributed sections; used to track them. */
  id: string;
  /**
   * Which posts it applies to. A section not listed for the post on screen
   * is not rendered — the OE sheet edits an OE of any type and a Stelle, and
   * most contributions want only one of them.
   */
  appliesTo: readonly OrgEditPostKind[];
  /**
   * The panel.
   *
   * It is handed `owner` (the post kind), `ownerId`, `organizationId` and
   * `canEdit` — the contract every contributed section is written against.
   */
  component: Type<unknown>;
}

export const ORG_EDIT_SHEET_SECTIONS = new InjectionToken<
  readonly OrgEditSheetSection[]
>('ORG_EDIT_SHEET_SECTIONS', { factory: () => [] });
